export const sectionHeaderStyle = {
  backgroundColor: "#EEF2FF",
  color: "#4F46E5",
  padding: "10px 14px",
  borderRadius: "6px",
  fontWeight: 600,
  fontSize: "0.95rem",
  marginBottom: "16px",
};

export const getRouteTableHeaderColors = (isProd = false) => ({
  headerBg: isProd ? "#043555" : "#EC1117",
  headerText: "#FFFFFF",
  headerBorder: isProd ? "#032f49" : "#c90e13",
});

export const getTableHeaderStyle = (isProd = false) => {
  const { headerBg, headerText, headerBorder } = getRouteTableHeaderColors(isProd);

  return {
    backgroundColor: headerBg,
    color: headerText,
    padding: "12px 16px",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "center",
    borderBottom: `1px solid ${headerBorder}`,
  };
};

export const tableHeaderStyle = getTableHeaderStyle(false);

export const tableCellStyle = {
  padding: "12px 16px",
  fontSize: "14px",
  textAlign: "center",
  border: "1px solid #E0E0E0",
  color: "#374151",
  backgroundColor: "#FFFFFF",
};

export const getVehicleNumber = (vehicle = {}) =>
  vehicle.otherNo ??
  vehicle.vehicleNumber ??
  vehicle.vehicleNo ??
  vehicle.registrationNo ??
  "";

export const parseAssignedVehicles = (row) => {
  const fromDetails =
    row?.vehicleDetails?.vehicleNumber ??
    row?.vehicleDetails?.otherNo ??
    row?.vehicleDetails?.vehicleNo;

  if (fromDetails) {
    return [
      {
        vehicleId: row?.vehicleId ?? row?.vehicleDetails?.vehicleId ?? "existing-0",
        vehicleNumber: fromDetails,
      },
    ];
  }

  const vehicleText = row?.vehicle;
  if (!vehicleText || vehicleText === "-") return [];

  return vehicleText
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
    .map((vehicleNumber, index) => ({
      vehicleId: row?.vehicleId ?? `existing-${index}`,
      vehicleNumber,
    }));
};

export const hasAssignedVehicle = (row) => parseAssignedVehicles(row).length > 0;

export const getCurrentAssignedVehicleLabel = (row) => {
  const vehicles = parseAssignedVehicles(row);
  return vehicles[0]?.vehicleNumber ?? "";
};
